import { render, staticRenderFns } from "./DetailsPrepaidsItem.vue?vue&type=template&id=c37bcf0e&scoped=true&"
import script from "./DetailsPrepaidsItem.vue?vue&type=script&lang=js&"
export * from "./DetailsPrepaidsItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPrepaidsItem.vue?vue&type=style&index=0&id=c37bcf0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37bcf0e",
  null
  
)

export default component.exports